/*
  Pass array of string[] to return an object {[key: string]: boolean};
 */

/* eslint-disable */
const arrayToHash = (array) => array.reduce((a, b) => (a[b] = true, a), {});

export default arrayToHash;
